export const getStyles = () => {
    const styles = {
        svgIcon: {
            fontSize: 26
        },
        name: {
            wordBreak: 'break-all',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            lineHeight: 1.2,
        },
        cell: {
            py: 1
        }
    };
    return styles;
};